import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';

/**
 * When searching for keywords, we don't always want to include the [Other Traffic] result,
 * so this util can be applied to request builder to remove the [Other Traffic] result.
 */
export default function removeOtherTraffic(requestBuilder: AdvancedSearchRequestBuilder) {
  return requestBuilder.addConditionTermFilter('searchTerm', 'must_not', ['[other_traffic]', '[Other Traffic]']);
}
